import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BannerUpdate from '../BannerUpdate/BannerUpadate';
import './ExamCalendar.css';
import API_URL from '../../api/ExamCalendarApi';

const ExamCalendar = () => {
  const [title, setTitle] = useState('');
  const [pdfFile, setPdfFile] = useState(null);
  const [examCalendars, setExamCalendars] = useState([]);
  const [editingId, setEditingId] = useState(null); // Track the exam being edited

  // Fetch all exam calendar entries from the backend
  useEffect(() => {
    fetchExamCalendars();
  }, [API_URL]);

  const fetchExamCalendars = () => {
    axios.get(`${API_URL}/examcalender/all`)
      .then(response => setExamCalendars(response.data))
      .catch(error => console.error('Error fetching exam calendars:', error));
  };

  // Handle form submission to add or edit an exam calendar
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('pdf', pdfFile);

    if (editingId) {
      // Update existing exam calendar
      axios.put(`${API_URL}/examcalender/edit/${editingId}`, formData)
        .then(response => {
          alert('Exam calendar updated successfully!');
          fetchExamCalendars(); // Refresh the list after update
          setEditingId(null); // Exit editing mode
          setTitle('');
          setPdfFile(null);
        })
        .catch(error => console.error('Error updating exam calendar:', error));
    } else {
      // Add new exam calendar
      axios.post(`${API_URL}/examcalender/add`, formData)
        .then(response => {
          alert('Exam calendar added successfully!');
          setExamCalendars([...examCalendars, response.data]); // Update the list
          setTitle('');
          setPdfFile(null);
        })
        .catch(error => console.error('Error uploading exam calendar:', error));
    }
  };

  // Handle edit action
  const handleEdit = (exam) => {
    setEditingId(exam._id); // Set the exam ID for editing
    setTitle(exam.title); // Pre-fill title for editing
    window.scrollTo(0, 0);
  };

  // Handle delete action
  const handleDelete = (id) => {
    axios.delete(`${API_URL}/examcalender/delete/${id}`)
      .then(() => {
        alert('Exam calendar deleted successfully!');
        setExamCalendars(examCalendars.filter(exam => exam._id !== id)); // Remove from list
      })
      .catch(error => console.error('Error deleting exam calendar:', error));
  };

  return (
    <div className="admin-examcalendar-container">
      <div className='admin-examcalendar-section'>
      
      <h2 className="admin-examcalendar-heading">{editingId ? 'Edit Exam Calendar' : 'Manage Exam Calendars'}</h2>
      <BannerUpdate pageName="examCalender"/>

      {/* Form to add or edit exam calendar */}
      <form onSubmit={handleSubmit} className="admin-examcalendar-form">
        <div className="admin-examcalendar-form-group">
          <label htmlFor="title" className="admin-examcalendar-label">Title</label>
          <input
            type="text"
            className="admin-examcalendar-input"
            id="title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="admin-examcalendar-form-group">
          <label htmlFor="pdf" className="admin-examcalendar-label">PDF File</label>
          <input
            type="file"
            className="admin-examcalendar-input"
            id="pdf"
            accept=".pdf"
            onChange={e => setPdfFile(e.target.files[0])}
            required={!editingId} // PDF is required only when adding a new exam
          />
        </div>
        <button type="submit" className="admin-examcalendar-button">
          {editingId ? 'Update' : 'Upload'}
        </button>
      </form>

      {/* List of all exam calendars */}
      <h3 className="admin-examcalendar-subheading">Existing Exam Calendars</h3>
      <div className="admin-examcalendar-table-wrapper">
      <table className="admin-examcalendar-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>PDF Link</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {examCalendars.map(exam => (
            <tr key={exam._id}>
              <td>{exam.title}</td>
              <td>
                <a href={exam.pdfLink} target="_blank" rel="noopener noreferrer">View PDF</a>
              </td>
              <td className="admin-examcalendar-actions">
                <button className="admin-examcalendar-edit-button" onClick={() => handleEdit(exam)}>Edit</button>
                <button className="admin-examcalendar-delete-button" onClick={() => handleDelete(exam._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      </div>
    </div>
  );
};

export default ExamCalendar;